import React, { useState } from 'react';
import { signIn } from '../auth';
import { fetchUserProfile, cacheProfile } from '../api/users';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await signIn({ username: email, password });
      if (result.nextStep?.signInStep === 'CONFIRM_SIGN_UP') {
        navigate(`/confirm-email?email=${encodeURIComponent(email)}`);
        return;
      }
      const profile = await fetchUserProfile();
      cacheProfile(profile);
      navigate(profile.profileComplete ? '/catalog' : '/profile');
    } catch (err) {
      if (err.name === 'UserAlreadyAuthenticatedException') {
        try {
          const profile = await fetchUserProfile();
          cacheProfile(profile);
          navigate(profile.profileComplete ? '/catalog' : '/profile');
          return;
        } catch {
          navigate('/');
          return;
        }
      }
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, mx: 'auto', mt: 8, p: 3 }}>
      <Typography variant="h5" mb={3}>{t('login.title')}</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <TextField label={t('login.email')} type="email" fullWidth required
        value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }} />
      <TextField label={t('login.password')} type="password" fullWidth required
        value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 3 }} />
      <Button type="submit" variant="contained" fullWidth disabled={loading}>
        {loading ? t('login.submitting') : t('login.submit')}
      </Button>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Link to="/register">{t('login.createAccount')}</Link>
        <Link to="/forgot-password">{t('login.forgotPassword')}</Link>
      </Box>
    </Box>
  );
}
